import { createFetcher } from '../../Common';

import { CAREERS_FORM_SUBMIT, getBaseUrl } from '../../constants';

export class CareerForm {
  static getInstance() {
    if (!this.instance) {
      this.instance = new CareerForm(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.fetcher = fetcher;
    this.endpoint = CAREERS_FORM_SUBMIT;
  }

  get base_url() {
    return getBaseUrl();
  }

  /**
   * Submit career form data
   * @param {Object} formData - The form data to submit
   * @param {boolean} skipAuth - Whether to skip authentication
   * @returns {Promise<Object>} Response data
   */
  async submitCareerForm(formData, tokenObj, actionType, reCaptchaKey) {
    let token = null;
    if (typeof tokenObj === 'string') {
      token = tokenObj;
    } else if (tokenObj && tokenObj['g-recaptcha-response']) {
      token = tokenObj['g-recaptcha-response'];
    } else if (tokenObj && tokenObj.token) {
      token = tokenObj.token;
    }

    if (!token) {
      throw new Error('Invalid reCAPTCHA token');
    }

    const url = `${this.base_url + this.endpoint}`;
    const response = await this.fetcher.postDataWithCustomHeader(url, formData, {
      'g-recaptcha-response': token,
      'g-recaptcha-action': actionType,
      'g-recaptcha-key': reCaptchaKey,
    });
    return response?.data;
  }
}

export const createCareerForm = () => CareerForm.getInstance();
